"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BehaviorCodeNotificationTemplateVariablesDto = void 0;
const notification_templates_1 = require("../notification-templates");
class BehaviorCodeNotificationTemplateVariablesDto extends notification_templates_1.BaseTemplateVariablesDto {
    constructor(userInviteTemplateVariablesOptions) {
        super();
        Object.assign(this, userInviteTemplateVariablesOptions);
    }
    mapFields(source, skipNested, skipTransforms) {
        super.mapFields(source, skipNested, skipTransforms);
        return this;
    }
    getFields() {
        return [...super.getFields()];
    }
    SCHOOL_NAME;
    SCHOOL_ADDRESS;
    SCHOOL_CITY;
    SCHOOL_STATE;
    SCHOOL_ZIP;
    SCHOOL_PHONE;
    SCHOOL_GROUP_NAME;
    DATE_WEEKDAY;
    DATE_MONTH;
    DATE_DAY;
    DATE_YEAR;
    STUDENT_FIRST_NAME;
    STUDENT_MIDDLE_NAME;
    STUDENT_LAST_NAME;
    STUDENT_STUDENT_ID;
    GUARDIAN_NAME;
    GUARDIAN_ADDRESS;
    GUARDIAN_CITY;
    GUARDIAN_STATE;
    GUARDIAN_ZIP;
    ACTIVITY_TRACKINGS;
    ACTIVITY_TRACKING_LENGTH;
    HISTORYREPORTTABLE;
}
exports.BehaviorCodeNotificationTemplateVariablesDto = BehaviorCodeNotificationTemplateVariablesDto;
